import * as React from 'react';

export type DevicePlatform = 'mobile' | 'desktop';

export interface DeviceContext {
  platform: DevicePlatform;
}

export const deviceContext = React.createContext<DeviceContext>(null as any);
